{
  "it": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Cambia tappa",
        "reset_columns": "Reimposta colonne"
      },
      "labels": {
        "columns": "Colonne",
        "milestone": "Selezioni una nuova tappa",
        "no_results": "Nessuna unità trovata"
      }
    }
  }
}
